"use client";

import { useState } from "react";
import { Row, Col, Form } from "react-bootstrap";
import { Link } from "react-router-dom";
import { useDataFetch } from "../../../hooks/use-data-fetch"; 

const ForgotPasswordForm = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const { postData } = useDataFetch();
  const { mutateAsync: sendResetEmail, isPending } = postData("/users/reset/password");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setMessage(null);
    setError(null);

    if (!email) {
      setError("Por favor ingresa un correo electrónico.");
      return;
    }

    try {
      await sendResetEmail({ email });
      setMessage("Se han enviado las instrucciones para restablecer la contraseña a tu correo.");
      setEmail("");
    } catch (err: any) {
      setError(err?.response?.data?.message || err?.message || "Error al enviar las instrucciones.");
    }
  };

  return (
    <div className="auth-main-content m-auto m-1230 px-3">
      <Row className="align-items-center">
        <Col lg={6} className="d-none d-lg-block">
          <img
            src="/images/login_mth.jpg"
            className="rounded-3"
            alt="olvide contraseña"
            width={646}
            height={804}
          />
        </Col>

        <Col lg={6}>
          <div className="mw-480 ms-lg-auto">
            <div className="d-inline-block mb-4">
              <img
                src="/images/logo.svg"
                className="rounded-3 for-light-logo"
                alt="logo"
                width={200}
              />
              <img
                src="/images/logo.svg"
                className="rounded-3 for-dark-logo"
                alt="logo"
                width={200}
              />
            </div>

            <h3 className="fs-28 mb-2">¿Olvidaste tu contraseña?</h3>
            <p className="fw-medium fs-16 mb-4">
              Ingresa el correo electrónico que usaste al registrarte y te enviaremos instrucciones para restablecer tu contraseña.
            </p>

            <Form onSubmit={handleSubmit}>
              <Form.Group className="mb-4">
                <label className="label text-secondary">Correo Electrónico</label>
                <Form.Control
                  type="email"
                  className="h-55"
                  placeholder="ejemplo@correo.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </Form.Group>

              {message && <p className="text-success mb-3">{message}</p>}
              {error && <p className="text-danger mb-3">{error}</p>}

              <Form.Group className="mb-4">
                <button
                  type="submit"
                  className="btn btn-primary fw-medium py-2 px-3 w-100"
                  disabled={isPending}
                >
                  <div className="d-flex align-items-center justify-content-center py-1">
                    <span className="material-symbols-outlined fs-20 text-white me-2">
                      autorenew
                    </span>
                    <span>{isPending ? "Enviando..." : "Enviar"}</span>
                  </div>
                </button>
              </Form.Group>

              <Form.Group>
                <p>
                  Volver a{" "}
                  <Link
                    to="/login"
                    className="fw-medium text-primary text-decoration-none"
                  >
                    Iniciar Sesión
                  </Link>
                </p>
              </Form.Group>
            </Form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default ForgotPasswordForm;
